import { Component, Show } from 'solid-js';
import { NavigationProvider, useNavigation } from './contexts/NavigationContext';
import Header from './components/Header';
import Footer from './components/Footer';
import Projects from './components/Projects';
import BlogListPage from './pages/BlogListPage';
import BlogPost from './components/blog/BlogPost';
import CVPage from './pages/CVPage';
import './styles.css';

const AppContent: Component = () => {
  const { currentPage, currentArticleSlug } = useNavigation();

  console.log('AppContent render - currentPage:', currentPage(), 'slug:', currentArticleSlug());

  return (
    <div class="app">
      <Header />
      <main>
        <Show when={currentPage() === 'home'}>
          <Projects />
        </Show>

        <Show when={currentPage() === 'blog'}>
          <BlogListPage />
        </Show>

        <Show when={currentPage() === 'blog-article' && currentArticleSlug()}>
          <BlogPost slug={currentArticleSlug()!} />
        </Show>

        <Show when={currentPage() === 'cv'}>
          <CVPage />
        </Show>
      </main>
      <Footer />
    </div>
  );
};

const App: Component = () => {
  return (
    <NavigationProvider>
      <AppContent />
    </NavigationProvider>
  );
};

export default App;
